import { Box } from '@mui/material'
import { DataExplorerTable } from 'features/data-explorer/types'
import { ProcessingJob } from 'features/jobs/types'
import JobProcessingItem from 'features/jobs/ui/JobItem/JobProcessingItem/JobProcessingItem'
import { JobStatusType } from 'features/jobs/types'
import JobSuccess from './JobSuccess'
import { Alert, Button, DialogContent, DialogFooter } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import DocLink from 'features/common/ui/utils/DocLink'
import { DOCS_MANAGING_SUBSCRIPTIONS } from 'app/constants/urls'

interface JobStatusProps {
  table: DataExplorerTable
  job: ProcessingJob
  onClose: (jobStatus?: JobStatusType) => void
}

function JobStatus({ table, job, onClose }: JobStatusProps) {
  const jobStatus = job.status?.status
  const hasFailedBecauseCantBeTranformed =
    jobStatus === JobStatusType.Failure &&
    new RegExp('Only simple types may be exported as CSV', 'ig').test(job.status?.error?.msg || '')

  return (
    <>
      <DialogContent>
        {hasFailedBecauseCantBeTranformed && (
          <Box>
            <Alert severity="warning">
              <FormattedMessage
                id="data-explorer.subscription.exportDialog.cantTransform"
                values={{
                  a: (content) => <DocLink docUrl={DOCS_MANAGING_SUBSCRIPTIONS}>{content}</DocLink>
                }}
              />
            </Alert>
          </Box>
        )}
        {jobStatus === JobStatusType.Success ? (
          <JobSuccess table={table} job={job} />
        ) : (
          <JobProcessingItem job={job} padded={false} />
        )}
      </DialogContent>

      <DialogFooter>
        <Button variant="contained" onClick={() => onClose(jobStatus)}>
          {jobStatus === JobStatusType.Success ? (
            <FormattedMessage id="data-explorer.subscription.exportDialog.done" />
          ) : jobStatus === JobStatusType.Failure ? (
            <FormattedMessage id="data-explorer.subscription.exportDialog.retry" />
          ) : (
            <FormattedMessage id="data-explorer.subscription.exportDialog.minimize" />
          )}
        </Button>
      </DialogFooter>
    </>
  )
}

export default JobStatus
